exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".links-44c8eeb4{display:flex;flex-flow:column nowrap}.disabledLink-a7aad2d3{color:#BDBDBD;cursor:pointer}.links-44c8eeb4>a,span.disabledLink-a7aad2d3{font-weight:500;display:flex;align-items:center;padding-top:15px}.links-44c8eeb4>a:first-child,span.disabledLink-a7aad2d3:first-child{padding-top:0px}.links-44c8eeb4>a img,span.disabledLink-a7aad2d3 img{padding-right:15px}\n", ""]);

// Exports
exports.locals = {
	"links": "links-44c8eeb4",
	"disabledLink": "disabledLink-a7aad2d3"
};